import React from "react";
import { motion } from "framer-motion";

interface ResultsScreenProps {
  lastRushScore: {
    score: number;
    served: number;
    tips: number;
    combos: number;
    legendaries: number;
    categories: number;
  };
  onMainMenu: () => void;
  onPlayAgain: () => void;
  isLoading: boolean;
}

const ResultsScreen: React.FC<ResultsScreenProps> = ({
  lastRushScore,
  onMainMenu,
  onPlayAgain,
  isLoading,
}) => {
  const { score, served, tips, combos, legendaries, categories } = lastRushScore;
  return (
    <div className="results-screen h-full w-full bg-bg-main flex flex-col items-center justify-center p-4">
      <motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        className="bg-surface p-8 rounded-lg shadow-md border border-border-color w-full max-w-md text-center"
      >
        <h1 className="results-title text-3xl font-bold text-text-primary mb-2">Rush Mode Over!</h1>
        <p className="results-score text-5xl font-bold text-accent mb-6">{score.toLocaleString()}</p>
        <div className="text-left space-y-2 mb-6 text-text-secondary">
          <div className="flex justify-between text-lg"><span >Drinks Served:</span> <span className="font-semibold text-text-primary">{served}</span></div>
          <div className="flex justify-between text-lg"><span >Tips Earned:</span> <span className="font-semibold text-text-primary">{tips}💰</span></div>
          <div className="flex justify-between text-lg"><span >New Combos:</span> <span className="font-semibold text-text-primary">{combos}</span></div>
          <div className="flex justify-between text-lg"><span >Legendaries Served:</span> <span className="font-semibold text-text-primary">{legendaries}</span></div>
          <div className="flex justify-between text-lg"><span >Categories Touched:</span> <span className="font-semibold text-text-primary">{categories}</span></div>
        </div>
        <div className="flex gap-4">
          <button
            onClick={onMainMenu}
            disabled={isLoading}
            className="flex-1 bg-text-secondary text-white font-bold py-3 rounded-lg hover:opacity-90 disabled:bg-gray-400"
          >
            Main Menu
          </button>
          <button
            onClick={onPlayAgain}
            disabled={isLoading}
            className="flex-1 bg-danger text-white font-bold py-3 rounded-lg hover:opacity-90 disabled:bg-gray-400"
          >
            Play Again
          </button>
        </div>
      </motion.div>
    </div>
  );
};

export default ResultsScreen;
